var map = {
	"./cbr.svg": 1935,
	"./cub.svg": 26674,
	"./dese.svg": 63313,
	"./desi.svg": 27557,
	"./esin.svg": 25229,
	"./exp.svg": 96753,
	"./hsin.svg": 60906,
	"./ihsin.svg": 85375,
	"./ipar.svg": 2998,
	"./iqsin.svg": 29280,
	"./log.svg": 82674,
	"./losi.svg": 8955,
	"./nofade.svg": 43463,
	"./par.svg": 89533,
	"./qsin.svg": 50761,
	"./qua.svg": 10007,
	"./squ.svg": 57977,
	"./tri.svg": 38935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1516;